import React, { useState } from "react";
import Navigation from "./Navigation";
import { t } from "../i18n";

const API = process.env.REACT_APP_API_URL || "";

// Premier lancement d'une instance : tant qu'aucun superadmin n'existe, c'est le
// seul écran accessible — avant l'accueil, avant la connexion, avant tout. Le
// premier venu doit être celui qui installe le jeu, pas un joueur de passage.
// Rend le compte créé via onDone(account) : il est déjà connecté.
function Setup({ onDone }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!username.trim()) return setError(t("admin.setupNoUsername"));
    if (password.length < 6) return setError(t("admin.setupShortPassword"));
    if (password !== confirm) return setError(t("admin.setupMismatch"));
    setBusy(true);
    try {
      const res = await fetch(`${API}/admin/setup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: username.trim(), password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) { setError(data.error || t("admin.createError")); setBusy(false); return; }
      onDone({ token: data.token, username: data.username, role: data.role });
    } catch (_) {
      setError(t("common.serverUnreachable"));
      setBusy(false);
    }
  };

  return (
    <div class="container">
      <Navigation />
      <div class="Home">
        <div class="centered-content">
          <div class="main-title">{t("admin.welcomeTitle")}</div>
          <div class="main-subtitle">{t("setup.intro")}</div>
          <form class="auth-form" onSubmit={submit}>
            <input type="text" placeholder={t("admin.username")} value={username} autoComplete="username" autoFocus
              class={error ? "is-error" : undefined} aria-invalid={error ? "true" : undefined}
              onChange={e => setUsername(e.target.value)} />
            <input type="password" placeholder={t("admin.passwordMin")} value={password} autoComplete="new-password"
              onChange={e => setPassword(e.target.value)} />
            <input type="password" placeholder={t("admin.confirmPassword")} value={confirm} autoComplete="new-password"
              onChange={e => setConfirm(e.target.value)} />
            <p class="account-hint">{t("setup.hint")}</p>
            {error && <p class="auth-error">{error}</p>}
            <div class="btn-group vertical">
              <button class="btn btn-primary" type="submit" disabled={busy}>{t("admin.setupBtn")}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Setup;
